export default "__VITE_ASSET__efszhmtJ__"